/** @jsxImportSource @emotion/react */
import { Button, HeadingH3 } from 'components/landing/ui';
import { arrowRight } from 'components/landing/ui/icons';
import { Link as RouterLink } from 'react-router-dom';

import gift from '../../images/gift.svg';
import password from '../../images/password.svg';
import tap from '../../images/tap.svg';

const RightCol = () => (
  <div
    css={{
      flexDirection: 'column',
      alignItems: 'center',
      button: { marginBottom: 30 },
      img: { marginRight: 30, width: 40 },
      '>div': { alignItems: 'center', width: '100%' },
      '>div:not(:last-of-type)': { marginBottom: 30 },
      '@media (min-width:992px)': {
        button: { width: '100%' },
      },
      '@media (min-width:1366px)': {
        '>div:not(:last-of-type)': { marginBottom: 40 },
        button: { marginBottom: 50 },
        img: { width: 50 },
      },
    }}
  >
    {/* <RouterLink to="/lk" target="_blank">
    </RouterLink> */}
    <Button
      type="blue"
      icon={arrowRight}
      onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
    >
      Забрать полный доступ
    </Button>

    <div>
      <img src={tap} />
      <HeadingH3>Простая установка в один клик</HeadingH3>
    </div>
    <div>
      <img src={password} />
      <HeadingH3>
        Не требует вашего <span css={{ color: 'red' }}>пароля</span> от ВК, безопасный доступ
      </HeadingH3>
    </div>
    <div>
      <img src={gift} />
      <HeadingH3>
        Можно пользоваться бесплатно или от{' '}
        <span css={{ whiteSpace: 'nowrap' }}>
          10 <span css={{ fontFamily: 'sans-serif', fontWeight: 400 }}>₽</span>
          /день
        </span>
      </HeadingH3>
    </div>
  </div>
);

export default RightCol;
